<div class="vcash-contact-page" style="margin-bottom: 70px;">

  <!-- TOP HEADER -->
  <section class="vcash-top">
    <div class="vcash-appbar">
      <a class="appbar-btn" routerLink="/Profile">
        <img [src]="isAr ? '/assets/e-commerce/icons/60.webp' : '/assets/e-commerce/icons/61.webp'" alt="back" />
      </a>

      <h1 class="appbar-title">{{ "Contact Us" | transloco }}</h1>

      <div class="appbar-btn appbar-btn--ghost" routerLink="/notifications">
        <img src="/assets/e-commerce/icons/55.webp" alt="notifications" />
      </div>
    </div>
  </section>

  <!-- CONTENT -->
  <div class="vcash-content">

    <!-- SUMMARY CARD -->
    <section class="contact-summary-card">
      <div class="contact-summary-left">
        <span class="contact-overline">{{ "Support" | transloco }}</span>
        <h2>{{ "Contact Us" | transloco }}</h2>
        <p>
          {{ "We’d love to hear from you. Reach us through email, phone, or social media." | transloco }}
        </p>
      </div>

      <div class="contact-summary-icon">
        <img src="/assets/e-commerce/icons/64.webp" alt="contact" />
      </div>
    </section>

    <!-- MAIN CONTACT CARD -->
    <section class="contact-main-card">
      <div class="contact-grid">

        <!-- LEFT -->
        <div class="contact-info">

          <div class="section-header">
            <span class="section-badge"></span>
            <h3>{{ "Get in touch" | transloco }}</h3>
          </div>

          <div class="info-list">
            <a href="mailto:hello@liopetshop.com" class="info-item">
              <div class="icon-box">
                <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <path
                    d="M4 6.5C4 5.67 4.67 5 5.5 5h13c.83 0 1.5.67 1.5 1.5v11c0 .83-.67 1.5-1.5 1.5h-13C4.67 19 4 18.33 4 17.5v-11Z"
                    stroke="currentColor" stroke-width="1.8" />
                  <path d="M5 7l7 5 7-5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
              </div>
              <div class="info-text">
                <span class="label">{{ "Email" | transloco }}</span>
                <span class="value">hello&#64;zazupets.com</span>
              </div>
            </a>

            <a href="tel:01103325333" class="info-item">
              <div class="icon-box">
                <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <path
                    d="M6.6 10.8c1.4 2.8 3.7 5.1 6.6 6.6l2.2-2.2c.3-.3.7-.4 1.1-.3 1.2.4 2.4.6 3.7.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1C10.1 21 3 13.9 3 5c0-.6.4-1 1-1h3.5c.6 0 1 .4 1 1 0 1.3.2 2.5.6 3.7.1.4 0 .8-.3 1.1l-2.2 2Z"
                    stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
              <div class="info-text">
                <span class="label">{{ "phone" | transloco }}</span>
                <span class="value">01103325333</span>
              </div>
            </a>
          </div>

          <div class="social-section">
            <h5>{{ "Follow Us" | transloco }}</h5>

            <div class="social-links">
              <a href="https://www.facebook.com/zazupets" target="_blank" rel="noopener noreferrer"
                class="social-link facebook">
                <span class="social-icon">
                  <svg viewBox="0 0 24 24" aria-hidden="true">
                    <path
                      d="M13.5 21v-7h2.4l.4-3h-2.8V9.1c0-.9.3-1.5 1.6-1.5H16V4.9c-.3 0-.9-.1-1.8-.1-2.7 0-4.3 1.6-4.3 4.6V11H7.5v3h2.4v7h3.6Z"
                      fill="currentColor" />
                  </svg>
                </span>
                <div class="social-text">
                  <span class="platform">{{ "Facebook" | transloco }}</span>
                  <span class="handle">zazupets</span>
                </div>
              </a>

              <a href="https://www.instagram.com/zazupetsshop/" target="_blank" rel="noopener noreferrer"
                class="social-link instagram">
                <span class="social-icon">
                  <svg viewBox="0 0 24 24" aria-hidden="true">
                    <defs>
                      <linearGradient id="igGradientContact" x1="0%" y1="100%" x2="100%" y2="0%">
                        <stop offset="0%" stop-color="#feda75" />
                        <stop offset="25%" stop-color="#fa7e1e" />
                        <stop offset="50%" stop-color="#d62976" />
                        <stop offset="75%" stop-color="#962fbf" />
                        <stop offset="100%" stop-color="#4f5bd5" />
                      </linearGradient>
                    </defs>
                    <rect x="3" y="3" width="18" height="18" rx="5" fill="url(#igGradientContact)" />
                    <circle cx="12" cy="12" r="4" fill="none" stroke="white" stroke-width="1.8" />
                    <circle cx="17" cy="7" r="1.2" fill="white" />
                  </svg>
                </span>
                <div class="social-text">
                  <span class="platform">{{ "Instagram" | transloco }}</span>
                  <span class="handle">zazupets</span>
                </div>
              </a>
            </div>
          </div>

        </div>

        <!-- RIGHT -->
        <div class="contact-visual d-none d-md-flex">
          <div class="visual-card">
            <img src="/assets/contact-us.png" alt="Contact Us" class="contact-us-image" />
          </div>
        </div>

      </div>
    </section>

  </div>
</div>